(function() {
    angular.module("app").controller("DeviceActionRefreshModalController", DeviceActionRefreshModalController)

    DeviceActionRefreshModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "performRefresh",
        "quantitySelected",
        "maxMessageBoardsForAction"
    ]

    function DeviceActionRefreshModalController(
        $scope,
        $uibModalInstance,
        performRefresh,
        quantitySelected,
        maxMessageBoardsForAction
    ){
        "use strict"

        $scope.quantitySelected          = quantitySelected
        $scope.maxMessageBoardsForAction = maxMessageBoardsForAction

        $scope.refresh = () => {
            $uibModalInstance.close(performRefresh())
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
